import { useState, useEffect } from 'react'
import api from 'Common/Client/Interceptor'
import API from 'Common/Client/endpoint'

const useFetchApiData = () => {
  const userId = localStorage.getItem('personalId')
  const role = localStorage.getItem('role')
  const [members, setMembers] = useState([])
  const [groups, setGroups] = useState([])

  useEffect(() => {
    fetchUserData()
  }, [])

  useEffect(() => {
    if (role === 'Mentor') {
      fetchMentorData()
    }
  }, [role])

  const fetchUserData = async () => {
    try {
      const response = await api.get(API.chats.addChat, {
        params: { pageNumber: 1, pageSize: 30 },
      });
      // Endpoint now returns the paginated wrapper { items, totalCount, ... }
      const users = response.data.items || response.data.users || []

      if (users.length === 0) {
        console.warn('No users found for this role')
        return
      }

      const singleChatData = users.map((user) => ({
        id: user.userId,
        name: user.name,
      }))

      setMembers(singleChatData)
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  const fetchMentorData = async () => {
    try {
      const response = await api.get(API.chats.getMentorGroupList(userId), {
        params: { pageNumber: 1, pageSize: 30 },
      });

      const groups = response.data.items || response.data.groups || []

      if (groups.length === 0) {
        console.warn('No groups found for this mentor')
        return
      }

      const groupChatData = groups.map((group) => ({
        groupId: group.groupId,
        groupName: group.groupName,
      }))

      setGroups(groupChatData)
    } catch (error) {
      console.error('Error fetching group data:', error)
    }
  }

  return { members, groups }
}

export default useFetchApiData
